"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareClassServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class ShareClassServiceLive {
    getShareClasses(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = (yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-classes`));
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: [],
                };
            }
        });
    }
    getShareholderHoldingForShareClass(companyId, shareholderId, shareClassId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = (yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-classes/${shareClassId}/shareholder/${shareholderId}`));
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: null,
                };
            }
        });
    }
}
exports.ShareClassServiceLive = ShareClassServiceLive;
//# sourceMappingURL=ShareClassServiceLive.js.map